/* HH post-add cross-sell (Jordy CRO fix 3).

   HISTORY. This file was also the three-step accordion for the buy box (fix 6). The
   owner reverted that on 2 Oct 2026 - the buy box is the stacked layout again - so all
   the accordion code is gone from here. What is left is the cross-sell, which was never
   part of that change.

   WHAT IT DOES. The X2235BK add-on used to sit between the purchase options and Add to
   cart, where it competed with the button. It is offered AFTER a successful add
   instead: once per session, never pre-selected, dismissable, and only ever on the back
   of a real add-to-cart click - opening the drawer from the header cart icon does not
   trigger it.

   THE RULE THAT MATTERS: this file owns no buy-box state. The engine
   (assets/hh-sub-tiers.js) owns the cart, the prices, the selling plan and the line
   properties. Nothing here changes what the buy box adds.

   The one MutationObserver watches <cart-drawer>'s class attribute to know when the
   drawer opened. It only READS the drawer and appends a modal to <body>; it never
   writes to cart-drawer, so it cannot trigger itself. That matters - a non-idempotent
   write inside an observer is exactly what froze this page at 60fps on 29 Sep. */
(function () {
  'use strict';
  if (window.__hhBuyboxSteps) return;
  window.__hhBuyboxSteps = true;

  var armed = 0;                       /* timestamp of the last add-to-cart click */
  var XKEY = 'hh_xsell_seen';          /* once per session */

  function addonData() {
    var A = window.HH_TIERS && window.HH_TIERS.addon;
    return (A && A.variants && A.variants.length) ? A : null;
  }
  function seenX() { try { return sessionStorage.getItem(XKEY) === '1'; } catch (e) { return false; } }
  function markX() { try { sessionStorage.setItem(XKEY, '1'); } catch (e) {} }

  function drawerSections() {
    var cd = document.querySelector('cart-drawer');
    if (cd && typeof cd.getSectionsToRender === 'function') {
      return cd.getSectionsToRender().map(function (s) { return s.id; });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  /* Black November (25 Oct 2026): every glove is at least the SOLO rate off (40%, the same
     on both ladders in snippets/hh-bn-cfg.liquid), so show what the cart will charge, with
     the normal price struck through. Same per-box rounding as the cart. */
  function priceHtml(c) {
    var b = window.HH_BN_TILES;
    var pct = b && b.cfg && b.cfg.tiers && b.cfg.tiers[0] ? b.cfg.tiers[0].pct : 0;
    if (pct && document.documentElement.classList.contains('hh-bn')) {
      return '<s>$' + (c / 100).toFixed(2) + '</s> $' + ((c - Math.floor(c * pct / 100)) / 100).toFixed(2);
    }
    return '$' + (c / 100).toFixed(2);
  }

  function closeModal() {
    var m = document.getElementById('hh-xsell');
    if (m) m.parentNode.removeChild(m);
  }

  function showModal() {
    var A = addonData();
    if (!A || document.getElementById('hh-xsell')) return;
    var v0 = A.variants[0];
    var opts = A.variants.map(function (v) {
      return '<option value="' + v.id + '" data-price="' + v.price + '">' + v.title + '</option>';
    }).join('');

    var wrap = document.createElement('div');
    wrap.id = 'hh-xsell';
    wrap.className = 'hh-xs';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.setAttribute('aria-label', 'One more thing');
    wrap.innerHTML =
      '<div class="hh-xs-bd" data-hh-xclose></div>' +
      '<div class="hh-xs-card">' +
        '<button type="button" class="hh-xs-x" data-hh-xclose aria-label="Close">&times;</button>' +
        '<p class="hh-xs-kicker">One more thing</p>' +
        '<div class="hh-xs-row">' +
          '<img src="' + (A.img || '') + '" alt="" width="88" height="88" loading="lazy">' +
          '<div class="hh-xs-info">' +
            '<p class="hh-xs-name">' + A.title + '</p>' +
            '<p class="hh-xs-ben">Thin-gauge pack for the fine work &mdash; the jobs Grip-X is too heavy for.</p>' +
            '<p class="hh-xs-price" data-hh-xprice>' + priceHtml(v0.price) + '</p>' +
          '</div>' +
        '</div>' +
        '<label class="hh-xs-lab" for="hh-xs-size">Size</label>' +
        '<select id="hh-xs-size" class="hh-xs-sel" data-hh-xsize>' + opts + '</select>' +
        '<div class="hh-xs-btns">' +
          '<button type="button" class="hh-xs-yes" data-hh-xyes>Yes, add it</button>' +
          '<button type="button" class="hh-xs-no" data-hh-xclose>No thanks</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(wrap);

    var sel = wrap.querySelector('[data-hh-xsize]');
    sel.addEventListener('change', function () {
      var o = sel.options[sel.selectedIndex];
      var pr = parseInt(o.getAttribute('data-price'), 10) || 0;
      wrap.querySelector('[data-hh-xprice]').innerHTML = priceHtml(pr);
    });

    wrap.addEventListener('click', function (e) {
      if (e.target.closest('[data-hh-xclose]')) { closeModal(); return; }
      if (!e.target.closest('[data-hh-xyes]')) return;
      var btn = e.target.closest('[data-hh-xyes]');
      btn.disabled = true; btn.textContent = 'Adding...';
      var vid = parseInt(sel.value, 10);
      /* the page's own fetch, so Shopify records the add and fires the AddToCart pixels
         itself (25 Oct 2026 pixel audit - an iframe add was invisible to them) */
      window.fetch(window.location.origin + '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify({
          items: [{ id: vid, quantity: 1 }],
          sections: drawerSections(),
          sections_url: window.location.pathname
        })
      }).then(function (r) { return r.json(); }).then(function (d) {
        if (d && d.status && d.status >= 400) throw new Error('cart');
        var cd = document.querySelector('cart-drawer');
        if (cd && typeof cd.renderContents === 'function' && d && d.sections) {
          cd.classList.remove('is-empty');
          cd.renderContents(d);
          if (typeof cd.open === 'function') cd.open();
        }
        closeModal();
      })['catch'](function () {
        btn.disabled = false; btn.textContent = 'Yes, add it';
      });
    });

    document.addEventListener('keydown', function esc(e) {
      if (e.key === 'Escape') { closeModal(); document.removeEventListener('keydown', esc); }
    });
  }

  function watchDrawer() {
    var cd = document.querySelector('cart-drawer');
    if (!cd || !window.MutationObserver) return;
    new MutationObserver(function () {
      if (!cd.classList.contains('active')) return;
      /* Black November (4 Nov 2026): never cover the cart at checkout time */
      if (document.documentElement.classList.contains('hh-bn')) return;
      if (seenX() || !armed || (Date.now() - armed) > 12000) return;
      armed = 0;
      markX();
      setTimeout(showModal, 260);   /* let the drawer finish opening underneath */
    }).observe(cd, { attributes: true, attributeFilter: ['class'] });
  }

  /* The sticky bar is now ONE full-width Add to cart pill carrying the live total,
     and nothing else - owner call 2 Oct 2026. The product photo, the box-count select
     and the size chip are gone: the photo duplicates the gallery right above it, the
     bundle and size decisions are already made on the page, and on a phone the select
     covered the price so the total could not be read.

     The price stays live WITHOUT an observer. Rather than watch the node the engine
     rewrites on every render - the exact shape that froze this page at 60fps on
     29 Sep - the existing [data-hh-stickyprice] span is MOVED INSIDE the button, once.
     hh-sub-tiers.js renderCta() looks it up with bar.querySelector(), which does not
     care how deeply it is nested, so it keeps updating in place for free.

     The matching CSS (hiding the photo and the select, and making the button a
     full-width pill) is in assets/hh-buybox-steps.css and does NOT depend on this
     function running. */
  function slimSticky(tries) {
    var bar = document.querySelector('[data-hh-sticky]');
    var btn = bar && bar.querySelector('[data-hh-stickybtn]');
    var price = bar && bar.querySelector('[data-hh-stickyprice]');
    if (!bar || !btn || !price) {
      if ((tries || 0) < 60) setTimeout(function () { slimSticky((tries || 0) + 1); }, 150);
      return;
    }
    /* idempotent: appendChild of a node already there is a no-op move, but check
       anyway so a re-run never reshuffles the button's children */
    if (price.parentNode !== btn) btn.appendChild(price);
  }

  /* The "3 - Purchase options" heading is dropped (owner, 2 Oct 2026): the two plan
     cards underneath already name themselves, so the label was pure noise. Steps 1 and
     2 keep their headings because the controls under those are not self-describing.

     Safe to remove from the DOM, unlike [data-hh-incl]: nothing in hh-sub-tiers.js or
     hh-buybox-plus.js queries .hh-t-step, and the engine never re-creates it (it is
     static markup in sections/hh-sub-tiers.liquid, not something renderAll() writes).
     Matched on the leading "3" so it survives a copy change to the rest of the line. */
  function dropStep3(tries) {
    var root = document.querySelector('[data-hh-tiers]');
    var steps = root ? root.querySelectorAll('.hh-t-step') : [];
    if (!steps.length) {
      if ((tries || 0) < 60) return setTimeout(function () { dropStep3((tries || 0) + 1); }, 150);
      return;
    }
    Array.prototype.forEach.call(steps, function (s) {
      if (/^\s*3\s*[·.]/.test(s.textContent) && s.parentNode) s.parentNode.removeChild(s);
    });
  }

  function init(tries) {
    if (!tries) {
      slimSticky(0);
      dropStep3(0);
      /* arm only for a real add-to-cart click, from the buy box or the sticky bar */
      document.addEventListener('click', function (e) {
        if (!e.target || !e.target.closest) return;
        if (e.target.closest('[data-hh-add]') || e.target.closest('[data-hh-stickybtn]')) {
          armed = Date.now();
        }
      }, true);
    }
    if (!document.querySelector('cart-drawer') && (tries || 0) < 40) {
      return setTimeout(function () { init((tries || 0) + 1); }, 120);
    }
    watchDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(0); });
  } else {
    init(0);
  }
})();